import type { FC } from 'react';
import { Tooltip } from '@/react/components/core-ui/Tooltip';

import S from './styles.module.scss';

/**
 * Props for the ErrorSwatch component.
 */
interface IErrorSwatchProps {
  /** Optional CSS class name for the button wrapper. */
  className?: string;

  /** Optional error message to display in tooltip. */
  errorMessage?: string;
}

/**
 * A visual indicator for swatches with broken or invalid color data.
 *
 * Displays a bright red swatch with an exclamation mark to help identify
 * misconfigured products during development and QA testing.
 *
 * This component is only shown when the `productList.swatchErrorHandling`
 * config option is set to `showError` (default value in non-production
 * environments).
 */
export const ErrorSwatch: FC<IErrorSwatchProps> = ({
  className,
  errorMessage
}) => {
  const tooltipText =
    errorMessage !== undefined && errorMessage !== ''
      ? `Swatch Error: ${errorMessage}`
      : 'Invalid color data - please check product configuration';

  return (
    <div className={S.wrapper}>
      <Tooltip body={tooltipText} variant="dark" position="up" wrap>
        <button
          className={className ?? S.button}
          type="button"
          disabled
          onClick={(e) => {
            // Prevent click propagation to parent handlers
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div className={S.errorSwatch}>!</div>
        </button>
      </Tooltip>
    </div>
  );
};
